module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Chapter One")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h2', {
    staticClass: "h2title"
  }, [_vm._v("Would You Rather")]), _vm._v(" "), _c('p', {
    staticClass: "imageh"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Okay, I’ve got one,” my best friend Sadie said. “Would you rather have your own magic unicorn, but you have to keep it a secret, or have a regular horse that isn’t magic but everyone can know about it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The unicorn,” my other best friend, Isabel, said immediately. “Who wouldn’t choose the unicorn?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Sadie swallowed a mouthful of her peanut butter and banana sandwich. “I wouldn’t. I’d choose the horse so I could ride him to school and show him off to people and stuff. Horses aren’t magic ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("but they’re still beautiful.” She looked at me. “What about you, Anna?”")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I chewed a slice of apple while I thought. This was a hard one. Sadie was really good at this game. “I’m not sure,” I said. “I’d love to have a unicorn, but I can’t keep secrets from Banana.” Banana always seems to know what I’m thinking. That’s part of what makes her the best dog ever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sadie grinned. “Telling Banana wouldn’t count.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, but I’d also want to tell you guys,” I said. “So I choose the horse.” I pictured the three of us riding through a field on a chestnut mare. We’d braid her mane and brush her coat until it shined, and I’d always keep sugar cubes in my pockets for her. The best part of having a horse would be sharing her with my friends.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0003-01.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("“My turn,” Isabel said. “Would you rather be a famous actor or a famous singer?”")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Actress!” Sadie said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Singer,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Me too. We can sing duets,” Isabel said to me.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("“Hey, then I want to be a singer too!” Sadie said. “No, wait. I’ll still be a famous actress and you guys can sing the sound tracks for all my movies.”")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Deal,” Isabel said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was my turn to ask a question next. I looked around the lunchroom for inspiration. “Hmm. Would you rather look like a troll but smell like roses, or be super pretty but always smell like the school cafeteria on hot-dog day?”")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0004-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ew!” Sadie said. We all burst into giggles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Banana loves hot dogs, which is funny because she’s also shaped like one, all long and skinny in the middle. The hot dogs we eat at home are tasty, but today’s hot lunch smelled like ketchup and skunk stew.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("At least the ketchup came in packets instead of squeeze bottles, so we didn’t have to listen to ketchup farts while we ate. My brother gets those bottles to make the grossest sounds possible. He’s disgustingly good at it.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d be a nice-smelling troll, definitely,” Isabel said when she’d caught her breath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sadie scrunched up her nose and shook her head. Her curls bounced. “I can’t answer this one,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’d still love you if you smelled like school lunch,” I promised her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’d just love you from a little farther away,” Isabel teased.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Sadie stuck out her tongue. She folded up her sandwich wrapper and wiped her lips with a paper napkin. As usual, Sadie’s side of the table ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("was much neater than Isabel’s and mine. Though most of the mess on our side was Isabel’s.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Isabel stuffed her own trash into her lunchbox. “Oh! I almost forgot,” she said, pulling out a piece of paper. “I brought you a surprise.” She smoothed out the wrinkles and thrust the paper at me. “Ta-da!”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 60
// module chunks = 0